import axios from 'axios'
import React from 'react'
import { baseUrl2 } from '../../config/clientsConfig'

const TeamService = {
    createTeam: async (data) => {
       return axios.post(`${baseUrl2}/teams/create`, data);
    },
    getAllTeams: async (body) => {
        return axios.post(`${baseUrl2}/teams/list`, body);
    },
    getTeamName : async (department = null) => {
        return axios.get(`${baseUrl2}/teams-names-list/${department}`);
    },
    getByIdTeam: async (id) => {
        return axios.get(`${baseUrl2}/teams/${id}`);
    },
    updateTeam: async (id, data) => {
        return axios.put(`${baseUrl2}/teams/${id}`, data);
    },
    getDepartmentTeamList : async (body) => {
        return axios.post(`${baseUrl2}/teams-names-department`, body);
    }
}
export default TeamService
